import { useMemo } from 'react';
import { AppointmentTypesTypes } from '@frontend/api-appointment-types';
import { useTranslation } from '@frontend/i18n';
import { Icon } from '@frontend/icons';
import { useScheduleSettingsSmallMode } from '../../hooks/settings/use-schedule-settings-small-mode';
import { AppointmentTypeCompactTable } from './AppointmentTypeCompactTable';
import { AppointmentTypeLargeTable } from './AppointmentTypeLargeTable';
import { AppointmentTypeTableProps } from './types';

type Props = {
  appointmentTypesData: AppointmentTypesTypes.AppointmentType[];
  handleEdit: (id: string) => void;
  handleDelete: (id: string) => void;
} & Omit<AppointmentTypeTableProps, 'tableRowActions'>;

export function AppointmentTypeTable({ appointmentTypesData, handleEdit, handleDelete, ...props }: Props) {
  const { t } = useTranslation('schedule');
  const { isSmallMode } = useScheduleSettingsSmallMode();

  const tableRowActions = useMemo(
    () => [
      {
        Icon: () => <Icon name='edit' />,
        label: t('Edit'),
        onClick: (row: AppointmentTypesTypes.AppointmentType) => handleEdit(row.id),
      },
      {
        Icon: () => <Icon name='trash' />,
        label: t('Delete'),
        onClick: (row: AppointmentTypesTypes.AppointmentType) => handleDelete(row.id),
      },
    ],
    [t]
  );

  return (
    <>
      {isSmallMode ? (
        <AppointmentTypeCompactTable
          tableRowActions={tableRowActions}
          appointmentTypesData={appointmentTypesData}
          {...props}
        />
      ) : (
        <AppointmentTypeLargeTable
          tableRowActions={tableRowActions}
          appointmentTypesData={appointmentTypesData}
          {...props}
        />
      )}
    </>
  );
}
